import {
  type DeliveryBenchmarkLane,
  stopBenchmarkFields,
  type StopBenchmarkFieldSource,
} from "./deliveryBenchmark";

export type VisitStatus = "ON_TIME" | "EARLY" | "LATE" | "UNKNOWN";

/**
 * Normalizes backend on-time status enums/strings into UI status keys.
 */
export function getVisitStatusFromOnTimeStatus(
  onTimeStatus: string | null | undefined,
): VisitStatus | null {
  if (!onTimeStatus) {
    return null;
  }

  const normalized = onTimeStatus.replace(/^ON_TIME_STATUS_/, "");
  if (normalized === "ON_TIME") return "ON_TIME";
  if (normalized === "EARLY") return "EARLY";
  if (normalized === "LATE") return "LATE";
  if (normalized === "UNKNOWN") return "UNKNOWN";
  return null;
}

/**
 * Normalizes backend contractual on-time status enums/strings into UI status keys.
 */
export function getVisitStatusFromContractualOnTimeStatus(
  contractualOnTimeStatus: string | null | undefined,
): VisitStatus | null {
  return getVisitStatusFromOnTimeStatus(contractualOnTimeStatus);
}

export function getVisitStatusForStopBenchmark(
  stop: StopBenchmarkFieldSource,
  lane: DeliveryBenchmarkLane,
): VisitStatus | null {
  const { statusKey } = stopBenchmarkFields(lane);
  return getVisitStatusFromOnTimeStatus(stop[statusKey]);
}

/**
 * Derives visit status from weighted deviation (minutes).
 * Positive = late, negative = early, zero/null/undefined = on time.
 */
export function getVisitStatus(
  weightedDeviationMinutes: number | null | undefined,
): VisitStatus {
  if (weightedDeviationMinutes != null) {
    if (weightedDeviationMinutes > 0) return "LATE";
    if (weightedDeviationMinutes < 0) return "EARLY";
    return "ON_TIME";
  }
  return "ON_TIME";
}
